export const NATIONALITY_SELECT = [
  { label: 'my_profile.nationality.afghan', value: 'Afghan', code: 'af' },
  { label: 'my_profile.nationality.argentine', value: 'Argentine', code: 'ar' },
  {
    label: 'my_profile.nationality.australian',
    value: 'Australian',
    code: 'au',
  },
  { label: 'my_profile.nationality.austrian', value: 'Austrian', code: 'at' },
  { label: 'my_profile.nationality.brazilian', value: 'Brazilian', code: 'br' },
  { label: 'my_profile.nationality.british', value: 'British', code: 'gb' },
  { label: 'my_profile.nationality.canadian', value: 'Canadian', code: 'ca' },
  { label: 'my_profile.nationality.chilean', value: 'Chilean', code: 'cl' },
  { label: 'my_profile.nationality.chinese', value: 'Chinese', code: 'cn' },
  { label: 'my_profile.nationality.colombian', value: 'Colombian', code: 'co' },
  { label: 'my_profile.nationality.cuban', value: 'Cuban', code: 'cu' },
  { label: 'my_profile.nationality.danish', value: 'Danish', code: 'dk' },
  { label: 'my_profile.nationality.dutch', value: 'Dutch', code: 'nl' },
  { label: 'my_profile.nationality.egyptian', value: 'Egyptian', code: 'eg' },
  { label: 'my_profile.nationality.english', value: 'English', code: 'gb' },
  { label: 'my_profile.nationality.filipino', value: 'Filipino', code: 'ph' },
  { label: 'my_profile.nationality.finnish', value: 'Finnish', code: 'fi' },
  { label: 'my_profile.nationality.french', value: 'French', code: 'fr' },
  { label: 'my_profile.nationality.german', value: 'German', code: 'de' },
  { label: 'my_profile.nationality.greek', value: 'Greek', code: 'gr' },
  { label: 'my_profile.nationality.indian', value: 'Indian', code: 'in' },
  { label: 'my_profile.nationality.irish', value: 'Irish', code: 'ie' },
  { label: 'my_profile.nationality.italian', value: 'Italian', code: 'it' },
  { label: 'my_profile.nationality.japanese', value: 'Japanese', code: 'jp' },
  { label: 'my_profile.nationality.korean', value: 'Korean', code: 'kr' },
  { label: 'my_profile.nationality.mexican', value: 'Mexican', code: 'mx' },
  { label: 'my_profile.nationality.moroccan', value: 'Moroccan', code: 'ma' },
  {
    label: 'my_profile.nationality.new_zealander',
    value: 'New Zealander',
    code: 'nz',
  },
  { label: 'my_profile.nationality.nigerian', value: 'Nigerian', code: 'ng' },
  { label: 'my_profile.nationality.norwegian', value: 'Norwegian', code: 'no' },
  { label: 'my_profile.nationality.peruvian', value: 'Peruvian', code: 'pe' },
  { label: 'my_profile.nationality.polish', value: 'Polish', code: 'pl' },
  {
    label: 'my_profile.nationality.portuguese',
    value: 'Portuguese',
    code: 'pt',
  },
  { label: 'my_profile.nationality.romanian', value: 'Romanian', code: 'ro' },
  { label: 'my_profile.nationality.russian', value: 'Russian', code: 'ru' },
  { label: 'my_profile.nationality.saudi', value: 'Saudi', code: 'sa' },
  { label: 'my_profile.nationality.scottish', value: 'Scottish', code: 'gb' }, // Reino Unido escocés
  {
    label: 'my_profile.nationality.south_african',
    value: 'South African',
    code: 'za',
  },
  { label: 'my_profile.nationality.spanish', value: 'Spanish', code: 'es' },
  { label: 'my_profile.nationality.swedish', value: 'Swedish', code: 'se' },
  { label: 'my_profile.nationality.swiss', value: 'Swiss', code: 'ch' },
  { label: 'my_profile.nationality.thai', value: 'Thai', code: 'th' },
  { label: 'my_profile.nationality.turkish', value: 'Turkish', code: 'tr' },
  { label: 'my_profile.nationality.ukrainian', value: 'Ukrainian', code: 'ua' },
  { label: 'my_profile.nationality.uruguayan', value: 'Uruguayan', code: 'uy' },
  {
    label: 'my_profile.nationality.venezuelan',
    value: 'Venezuelan',
    code: 've',
  },
  {
    label: 'my_profile.nationality.vietnamese',
    value: 'Vietnamese',
    code: 'vn',
  },
];